import { createApi } from '@reduxjs/toolkit/query/react';
import { API, graphqlOperation } from 'aws-amplify';
import { baseQuery } from '../baseQuery';
import { createTrialBalanceDashboardData } from '../../graphql/mutations';

export const trialBalanceApi = createApi({
    reducerPath: 'trialBalance',
    baseQuery: baseQuery,
    endpoints: (builder) => ({
        fetchTrialBalanceData: builder.query({
            query: ({ StartDate, EndDate, OpeningBalance }) => ({
                body: createTrialBalanceDashboardData,
                variables:{
                    StartDate,
                    EndDate,
                    OpeningBalance,
                }
            }),
            providesTags: ['TrialBalanceData'],
        }),
    }),
});

export const { useFetchTrialBalanceDataQuery,util: { invalidateTags } } = trialBalanceApi;
